import React, { useState, useEffect } from 'react';
import { CallToAction, CampaignFlow } from '@core/frontend/components';
import { CallToActionPlaceholder } from '@core/frontend/ui';
import { cleanLocationProp } from '@core/shared';
import { sendVirtualPageView } from '../../shared/tracking.js';
import { Row, Col } from 'reactstrap';
import axios from '../../http/httpClient.js';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

function Home(props) {
    const [ctas, setCtas] = useState(null);
    const [, setError] = useState(false);
    let location = useLocation();
    useEffect(() => {
        axios
            .get('/cta/', {
                params: {
                    page: cleanLocationProp(location.pathname),
                },
            })
            .then((response) => {
                setCtas(response.data);
            })
            .catch((error) => {
                setError(true);
            });
        sendVirtualPageView('Willkommen');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let cta = (
        <React.Fragment>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                <CallToActionPlaceholder />
            </Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                <CallToActionPlaceholder />
            </Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                <CallToActionPlaceholder />
            </Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                <CallToActionPlaceholder />
            </Col>
        </React.Fragment>
    );
    if (ctas) {
        cta = ctas.map((cta, key) => (
            <React.Fragment key={key}>
                {key === 2 ? (
                    <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                        <CampaignFlow />
                    </Col>
                ) : null}
                <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                    <CallToAction
                        btnClass={`anl_cta--${cta.page}--btn-${cta.position}`}
                        headline={cta.headline}
                        copy={cta.copy}
                        buttonText={cta.buttonText}
                        buttonColor={cta.buttonColor}
                        linkUrl={cta.linkUrl}
                        outline={cta.outline}
                        buttonVisibility={cta.buttonVisibility}
                    />
                </Col>
            </React.Fragment>
        ));
    }

    return (
        <>
            <Helmet>
                <title>{`Willkommen | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>
            <Row>{cta}</Row>
        </>
    );
}

export default Home;
